/**
 * Moonpage 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors, theme as brandTheme } from '@/config/brands'

function hexToRgba(color: string, alpha: number) {
  if (!color.startsWith('#'))
    return color

  const hex = color.slice(1)
  const normalizedHex = hex.length === 3
    ? hex.split('').map(char => char + char).join('')
    : hex

  const red = Number.parseInt(normalizedHex.slice(0, 2), 16)
  const green = Number.parseInt(normalizedHex.slice(2, 4), 16)
  const blue = Number.parseInt(normalizedHex.slice(4, 6), 16)

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

const primaryGradientStart = '#8DB8FF'
const primaryGradientEnd = brandTheme.primaryColor
const primaryGradient = brandTheme.primaryGradient || `linear-gradient(90deg, ${primaryGradientStart} 0%, ${primaryGradientEnd} 100%)`
const paymentStickyBgStart = brandTheme.bgGlobal || '#FFFFFF'
const paymentStickyGradient = `linear-gradient(to top, ${paymentStickyBgStart} 0%, ${paymentStickyBgStart} 34%, ${hexToRgba('#FFFFFF', 0.88)} 62%, ${hexToRgba('#FFFFFF', 0.5)} 82%, ${hexToRgba('#FFFFFF', 0)} 100%)`

export const moonpagePaymentConfig: BrandPaymentConfig = {
  brand: 'moonpage',

  pay: {
    theme: {
      isLightPaymentSelector: true,
      paymentStickyGradient,
    },
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/moonpage/welfare-gold.png',
    },
  },

  subscribe: {
    texts: subscribeCommonTexts,
    darkPaymentSelector: false,
    resources: {
      vipBg: '/images/moonpage/vip_bg.webp',
      memberSubscribeBg: '/images/moonpage/member_subscribe_bg.webp',
      vipIcon: '/images/moonpage/vip_icon2.png',
      vipDiscountIcon: '/images/moonpage/vip_discount.png',
      discountBg: '/images/moonpage/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: primaryGradient,
      purpleTextGradient: 'linear-gradient(180deg, #6D8CF1 0%, #4C7DFF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
      subscribeCardBg: 'linear-gradient(90deg, #FFFFFF 0%, #EEF4FF 100%)',
      cycleTextGradient: 'linear-gradient(180deg, #6D8CF1 0%, #4067E8 100%)',
      badgeGradient: 'linear-gradient(132deg, #8BA7FF 0%, #5E79F6 100%)',
    },
  },

  chapter: {
    texts: chapterCommonTexts,
    darkPaymentSelector: false,
    themeDefaults: {
      background: '#FFFFFF',
      size: '38',
    },
    colors: {
      coinsGradient: `linear-gradient(180deg, ${brandColors!.primary}, ${brandColors!.bg.global})`,
      coinsPopupText1: brandColors!.text.inverse,
      coinsPopupText2: primaryGradientStart,
      coinsPopupText3: brandColors!.text.secondary,
      coinsPopupText4: brandColors!.text.inverse,
      vipBg: brandColors!.bg.card,
      subscribeActiveBg: brandColors!.bg.card,
      purpleTextGradient: 'linear-gradient(180deg, #4C7DFF 0%, #8DB8FF 70%, #EEF4FF 100%)',
      pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      subscribeCardBg: 'linear-gradient(90deg, #FFFFFF 0%, #EEF4FF 100%)',
      purchaseActiveBg: '#EDF4FF',
      memberSubscribeBg: '/images/moonpage/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
